
import "@sparta.global.utilities/sparta-footnote-utility/dist/styles.css"
import "@sparta.global.utilities/sparta-sticky-utility/dist/styles.css"
import "@sparta.wealth-shared.modules/single-page-orchestration-module/dist/styles.css"
import "@sparta.my-merrill-login.modules/semantic-markup-runtime-module/dist/styles.css"
import "@sparta.authhelper.modules/ah-widget-loader-module/dist/styles.css"
import "@sparta.global-tenants.modules/gt-unauth-main-module/dist/styles.css"
import "@sparta.global-tenants.modules/gt-footer-unauth-placeholder-module/dist/styles.css"


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es5.js"
import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es5.js"
import syncTaggingUtility from "@sparta.global-vtim.utilities/sync-tagging-utility/dist/es5.js"
import ahVendorWrapperUtility from "@sparta.authglobal.utilities/ah-vendor-wrapper-utility/dist/es5.js"
import syncAlloyUtility from "@sparta.global-vtim.utilities/sync-alloy-utility/dist/es5.js"

import "@sparta.wealth-shared.modules/single-page-orchestration-module/dist/es5.js"
import "@sparta.my-merrill-login.modules/semantic-markup-runtime-module/dist/es5.js"
import "@sparta.authhelper.modules/ah-widget-loader-module/dist/es5.js"
import "@sparta.global-tenants.modules/gt-unauth-main-module/dist/es5.js"
import "@sparta.global-tenants.modules/gt-footer-unauth-placeholder-module/dist/es5.js"


window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [
    {
      name: "@sparta.secure-private-bank.modules/hero-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/secure-private-bank-hero-module-es5" */ "@sparta.secure-private-bank.modules/hero-module/dist/es5.js" ),import( /* webpackChunkName: "spa-assets/on-demand/secure-private-bank-hero-module-styles" */ "@sparta.secure-private-bank.modules/hero-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.secure-private-bank.modules/cta-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/secure-private-bank-cta-module-es5" */ "@sparta.secure-private-bank.modules/cta-module/dist/es5.js" ),import( /* webpackChunkName: "spa-assets/on-demand/secure-private-bank-cta-module-styles" */ "@sparta.secure-private-bank.modules/cta-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.login.modules/secure-ah-omni-channel-auth-first-factor-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/login-secure-ah-omni-channel-auth-first-factor-module-es5" */ "@sparta.login.modules/secure-ah-omni-channel-auth-first-factor-module/dist/es5.js" ),import( /* webpackChunkName: "spa-assets/on-demand/login-secure-ah-omni-channel-auth-first-factor-module-styles" */ "@sparta.login.modules/secure-ah-omni-channel-auth-first-factor-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.my-merrill-login.modules/squeezebox-modal-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/my-merrill-login-squeezebox-modal-module-es5" */ "@sparta.my-merrill-login.modules/squeezebox-modal-module/dist/es5.js" ),import( /* webpackChunkName: "spa-assets/on-demand/my-merrill-login-squeezebox-modal-module-styles" */ "@sparta.my-merrill-login.modules/squeezebox-modal-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.sales.modules/tiles-content-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/sales-tiles-content-module-es5" */ "@sparta.sales.modules/tiles-content-module/dist/es5.js" ),import( /* webpackChunkName: "spa-assets/on-demand/sales-tiles-content-module-styles" */ "@sparta.sales.modules/tiles-content-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.my-merrill-login.modules/finra-modal-footer-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/my-merrill-login-finra-modal-footer-module-es5" */ "@sparta.my-merrill-login.modules/finra-modal-footer-module/dist/es5.js" ),import( /* webpackChunkName: "spa-assets/on-demand/my-merrill-login-finra-modal-footer-module-styles" */ "@sparta.my-merrill-login.modules/finra-modal-footer-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.global.vendors/vue",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue" */ "@sparta.global.vendors/vue" )}
    },
    {
      name: "@sparta.global.vendors/vuex",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vuex" */ "@sparta.global.vendors/vuex" )}
    },
    {
      name: "@sparta.global.vendors/vue-router",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue-router" */ "@sparta.global.vendors/vue-router" )}
    }
  ],
  sharedComponents: [
    {
      name: "@sparta.login.shared-components/ah-secure-signin-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/login-ah-secure-signin-shared-component-es5" */ "@sparta.login.shared-components/ah-secure-signin-shared-component/dist/es5.js" )}
    },
    {
      name: "@sparta.login.shared-components/ah-passkey-signin-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/login-ah-passkey-signin-shared-component-es5" */ "@sparta.login.shared-components/ah-passkey-signin-shared-component/dist/es5.js" )}
    }
  ],
  stores: [
    {
      namespace: "@sparta.global-tenants.stores/gt-unauth-bootstrap-store",
                   loader: function() { return import( /* webpackChunkName: "spa-assets/js/stores/@sparta.global-tenants.stores/gt-unauth-bootstrap-store-es5" */ "@sparta.global-tenants.stores/gt-unauth-bootstrap-store/dist/es5.js" )}
    }
  ],
  jcrs: [
    {
      name: "site/secure-private-bank/module-specific/hero-module/hero-module.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-secure-private-bank-module-specific-hero-module-hero-module.json" */ "file:///apps/wt/deploy/tmp/7F938445/build/sit1a/site/sign-in/spa-assets/data/site-secure-private-bank-module-specific-hero-module-hero-module-en-T1785963587998.json" )}
    },
    {
      name: "site/secure-private-bank/module-specific/cta-module/en/cta-module_v1.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-secure-private-bank-module-specific-cta-module-en-cta-module_v1.json" */ "file:///apps/wt/deploy/tmp/7F938445/build/sit1a/site/sign-in/spa-assets/data/site-secure-private-bank-module-specific-cta-module-en-cta-module_v1-en-T1785963587998.json" )}
    },
    {
      name: "site/secure-private-bank/module-specific/squeezebox-modal-module/en/squeezebox-modal-module.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-secure-private-bank-module-specific-squeezebox-modal-module-en-squeezebox-modal-module.json" */ "file:///apps/wt/deploy/tmp/7F938445/build/sit1a/site/sign-in/spa-assets/data/site-secure-private-bank-module-specific-squeezebox-modal-module-en-squeezebox-modal-module-en-T1785963587998.json" )}
    },
    {
      name: "site/secure-private-bank/module-specific/tiles-content-module/content-section/en/content-section.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-secure-private-bank-module-specific-tiles-content-module-content-section-en-content-section.json" */ "file:///apps/wt/deploy/tmp/7F938445/build/sit1a/site/sign-in/spa-assets/data/site-secure-private-bank-module-specific-tiles-content-module-content-section-en-content-section-en-T1785963587998.json" )}
    },
    {
      name: "site/secure-private-bank/module-specific/tiles-content-module/box-section/en/box-section.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-secure-private-bank-module-specific-tiles-content-module-box-section-en-box-section.json" */ "file:///apps/wt/deploy/tmp/7F938445/build/sit1a/site/sign-in/spa-assets/data/site-secure-private-bank-module-specific-tiles-content-module-box-section-en-box-section-en-T1785963587998.json" )}
    },
    {
      name: "site/ah-secure-login/module-specific/hybrid/client-site-config.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-ah-secure-login-module-specific-hybrid-client-site-config.json" */ "file:///apps/wt/deploy/tmp/7F938445/build/sit1a/site/sign-in/spa-assets/data/site-ah-secure-login-module-specific-hybrid-client-site-config-en-T1785963587998.json" )}
    },
    {
      name: "site/secure-private-bank/module-specific/finra-modal-footer-module/en/broker-check.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-secure-private-bank-module-specific-finra-modal-footer-module-en-broker-check.json" */ "file:///apps/wt/deploy/tmp/7F938445/build/sit1a/site/sign-in/spa-assets/data/site-secure-private-bank-module-specific-finra-modal-footer-module-en-broker-check-en-T1785963587998.json" )}
    },
    {
      name: "/site/secure-ah-hybrid-shared-components/module-specific/ah-secure-signin-shared-component/en/data-v1.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/-site-secure-ah-hybrid-shared-components-module-specific-ah-secure-signin-shared-component-en-data-v1.json" */ "file:///apps/wt/deploy/tmp/7F938445/build/sit1a/site/sign-in/spa-assets/data/site-secure-ah-hybrid-shared-components-module-specific-ah-secure-signin-shared-component-en-data-v1-en-T1785963587998.json" )}
    },
    {
      name: "/site/secure-ah-hybrid-shared-components/module-specific/ah-secure-signin-shared-component/en/error-v1.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/-site-secure-ah-hybrid-shared-components-module-specific-ah-secure-signin-shared-component-en-error-v1.json" */ "file:///apps/wt/deploy/tmp/7F938445/build/sit1a/site/sign-in/spa-assets/data/site-secure-ah-hybrid-shared-components-module-specific-ah-secure-signin-shared-component-en-error-v1-en-T1785963587998.json" )}
    }
  ]
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  var bootExecs = [];
  bootExecs.push(function() { return spartaBootstrapUtility.init(arguments); });
  bootExecs.push(function() { return ahVendorWrapperUtility.init(); });
  bootExecs.reduce(function(cur, next) {
    return cur.then(next);
  }, Promise.resolve()).then(function() {
    console.log('after - execute boot functions')
  });
})();
